/*
 * @Author: Dom
 * @Date: 2022-05-13 09:27:30
 * @LastEditTime: 2022-08-22 17:07:07
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\layouts\UserLayout\routes.ts
 */
import { RoutesDataItem } from "@/utils/routes";

const UserLayoutRoutes: RoutesDataItem[] = [
    {
        title: 'user-layout.menu.login',
        path: 'login',
        component: () => import('@/views/user/login/index.vue'),
    },
    {
        title: 'user-layout.menu.register',
        path: 'register',
        component: () => import('@/views/user/register/index.vue'),
    },
    {
        title: 'user-layout.menu.activation',
        path: 'activation',
        component: () => import('@/views/user/activation/index.vue'),
    },
    {
        title: 'user-layout.menu.activationemail',
        path: 'activationemail',
        component: () => import('@/views/user/activationemail/index.vue'),
    },
    {
        title: 'user-layout.menu.success',
        path: 'success',
        component: () => import('@/views/user/success/index.vue'),
    }
];

export default UserLayoutRoutes;
